module.exports = __webpack_public_path__ + "img/logo-travessia.36ead283.png";